import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { QuoteModel } from '@bytel/bytel-sales';

import { ApiService } from '@services/api.service';
import { AppService } from '@services/app.services';
import { MainCartService } from '@services/main-cart.service';
import { MobileRecoveryService } from '@services/mobile-recovery.service';

import { merge } from 'rxjs';

import { MobileRecoveryStatus } from '../../interfaces/mobile-recovery.interface';
import { MobileRecoveryModel } from '../../models/mobile-recovery.model';
import { PriceComponent } from '../../trilogy/price/price.component';
import { TicketlineComponent } from '../ticket/ticketline/ticketline.component';

@Component({
    selector: 'checkout-mobile-recovery',
    templateUrl: './mobile-recovery.component.html',
    styleUrl: 'mobile-recovery.component.scss',
    standalone: true,
    imports: [NgClass, PriceComponent, TicketlineComponent],
})
export class MobileRecoveryComponent implements OnInit {
    public totalRecoveryAmount: number = 0;
    public isExpanded: boolean = true;
    public actionLabel: string;
    public canDelete: boolean = false;
    public recoveryData: MobileRecoveryModel;
    public isStarted: boolean = false;
    public hasEstimation: boolean = false;
    public showBonus: boolean = false;
    @Input() public noButtons: boolean = false;
    @Output() public displayRecoveryEvent = new EventEmitter<boolean>();

    constructor(
        private cartService: MainCartService,
        private mobileRecovery: MobileRecoveryService,
        private appService: AppService,
        private apiService: ApiService,
    ) {}

    public delete(): void {
        this.mobileRecovery.delete(this.recoveryData.recovery.criterias.id);
        this.apiService.pushCart().subscribe();
    }

    public ngOnInit(): void {
        this.initRecovery();

        merge(this.cartService.cartQuoteSubscription, this.mobileRecovery.recoveryActionObs).subscribe(() => {
            this.initRecovery();
        });
    }

    public redirect(): void {
        this.appService.navigateTo(this.recoveryData.product.item.url, { recovery: 'true' });
    }

    protected initRecovery(): void {
        const quote: QuoteModel = this.cartService.getQuote();
        this.recoveryData = this.mobileRecovery.getRecoveryForQuote(quote);

        if (this.recoveryData) {
            const status = this.recoveryData.status;
            switch (status) {
                case MobileRecoveryStatus.UNFINISHED:
                    this.actionLabel = 'Finaliser ma reprise';
                    break;

                case MobileRecoveryStatus.UNSTARTED:
                case MobileRecoveryStatus.ONGOING:
                    this.actionLabel = 'Estimer mon mobile';
                    break;
                case MobileRecoveryStatus.COMPLETED:
                    this.actionLabel = 'Modifier';
                    this.canDelete = true;
                    break;
            }
            this.totalRecoveryAmount = this.recoveryData.getAmount(quote);
            this.showBonus = this.recoveryData.hasBonus(quote);
            this.isStarted = this.recoveryData.isStarted();
            this.hasEstimation = this.recoveryData.hasEstimation();
        } else {
            this.isStarted = false;
            this.hasEstimation = false;
            this.canDelete = false;
            this.isExpanded = true;
            this.showBonus = false;
        }

        this.displayRecoveryEvent.emit(this.isStarted);
    }
}
